import React, { useEffect, useState } from "react";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { Spin } from "antd";

const AddHoliday = ({fetchdata, onClose, isOpen}) => {
  const [formData, setFormData] = useState({
    Reason: "",
    Date: "",
    Optional: false,
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddHoliday = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    if (tokenData && superIdData) {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/holidays/createHolidays`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify({
              superid: superIdData,
              holidaydt: formData.Date,
              reason: formData.Reason,
              createdby: 1,
              optional: formData.Optional ? 1 : 0,
            }),
          }
        );

        const responseData = await response.json();

        console.log("Response Data:", responseData);

        if (responseData.status) {
          setFormData({
            Reason: "",
            Date: "",
            Optional: false,
          });
          Swal.fire({
            title: "Success",
            text: "Holiday Added successfully",
            icon: "success",
          }).then(() => {
           fetchdata();
           handlecancel();
           onClose();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: responseData.Message || "Failed to add holiday.",
            icon: "error",
          });
        }
      } catch (error) {
        setSubmitLoading(false);
        console.error("Error adding holiday:", error.message);
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const handlecancel = () => {
    setFormData({
      Reason: "",
      Date: "",
      Optional: false,
    });
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddHoliday");

    const handleOffcanvasClose = () => {
      handlecancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  return (
    <>
      {isOpen && (
        <div>
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightAddHoliday {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightAddHoliday {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightAddHoliday {
            width: 27% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightAddHoliday {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightAddHoliday {
            width:12% !important;
          }
        }
        `}
          </style>
          {submitLoading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}

          <div className="offcanvas-backdrop fade show" onClick={onClose} />
          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightAddHoliday"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Add Holiday</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => {
                  handlecancel();
                  onClose();
                }}
                aria-label="Close"
              />
            </div>
            <hr />
            <div className="offcanvas-body">
              <form onSubmit={handleAddHoliday}>
                <div className="content">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span>Reason
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter reason"
                        name="Reason"
                        value={formData.Reason}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span>Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="Date"
                        value={formData.Date}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-6 mt-3 d-flex align-items-start">
                      <label className="form-label">Optional</label>
                      <input
                        type="checkbox"
                        className="ms-3"
                        name="Optional"
                        checked={formData.Optional}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            Optional: e.target.checked,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="row d-flex justify-content-end mt-3">
                    <div className="col-3 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={() => {
                          handlecancel();
                          onClose();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-3 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={submitLoading}
                      >
                        {submitLoading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

AddHoliday.propTypes = {
  fetchdata: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default AddHoliday;
